
/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */
import { useContext, useMemo } from 'react';
import { FormLookupsContext, getParentPropertyPath } from '@ngt/opms';
import React from 'react';

/*
 * ----------------------------------------------------------------------------------
 * Imports - Internal
 * ----------------------------------------------------------------------------------
 */
import * as Dtos from '../../../api/dtos';
import { useFieldActions, useFieldState, useScopedField } from '@ngt/forms-core';

/*
 * ----------------------------------------------------------------------------------
 * Components
 * ----------------------------------------------------------------------------------
 */
interface IInputDisplayProps {
    convert?: (value: any, lookups: Dtos.ILookup[]) => any;
    valueConvert?: (value: any, lookups: Dtos.ILookup[]) => any;
    specifyName?: string;
    specifyConvert?: (value: any, lookups: Dtos.ILookup[]) => any;
}

const InputDisplay: React.FunctionComponent<IInputDisplayProps> = ({
    convert,
    valueConvert,
    specifyName,
    specifyConvert
}) => {
    const lookups = useContext(FormLookupsContext);

    const { value } = useFieldState({ value: true });
    const { getPropertyPath } = useFieldActions();

    const parentName = useMemo(() => getParentPropertyPath(getPropertyPath()) ?? '', [getPropertyPath]);

    const { state: { value: specifyValue } } = useScopedField(specifyName ? `${parentName}.${specifyName}` : '_U_N_K_N_O_W_N_', { value: true })

    const convertToUse = convert ?? valueConvert;

    const convertedValue = useMemo(() => {
        return convertToUse ? convertToUse(value, lookups ? lookups : []) : value;
    }, [convertToUse, value, lookups])

    const convertedSpecifyValue = useMemo(() => {
        return specifyConvert ? specifyConvert(specifyValue, lookups ? lookups : []) : undefined;
    }, [specifyConvert, specifyValue, lookups])

    return (
        <>
            {convertedValue}
            {convertedSpecifyValue}
            {convertedSpecifyValue}
        </>
    );

}


export default InputDisplay;